import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {FiSearch, FiX} from 'react-icons/fi'
import _ from 'lodash'
import {VmoHeader, VmoHeaderSubheader, VmoImage, VmoMenuItem, VmoSearch, VmoTooltip} from 'vmo-library'

import {globalSearch} from 'actions'
import {GLOBAL_SEARCH} from 'actions/types'
import book from 'assets/nav-book.svg'
import contact from 'assets/nav-contact.svg'
import inbox from 'assets/nav-inbox.svg'
import task from 'assets/nav-task.svg'
import {get, getFullNameFromObj, startCase, wrapText} from 'utils/helper'
import {KNOWLEDGEBASE_PATH} from 'constants/path'

const GlobalSearch = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isSearchEnable, setIsSearchEnable] = useState(false)
  const [search, setSearch] = useState({
    // isLoading: false,
    value: null,
    results: [],
  })

  const {successLabels = []} = useSelector(state => state.apiReducer)
  const {globalSearchData = {}} = useSelector(state => state.appReducer)

  useEffect(() => {
    if (search.value !== null) {
      dispatch(globalSearch(search.value))
    }
  }, [search.value, dispatch])

  useEffect(() => {
    if (successLabels.includes(GLOBAL_SEARCH)) {
      const arr = Object.keys(globalSearchData).reduce((acc, ele) => {
        globalSearchData[ele].map(single => {
          let obj = {}

          switch (ele) {
            case 'contacts': {
              obj = {
                key: single.id,
                title: wrapText(getFullNameFromObj(single), 20),
                price: startCase(ele),
                image: contact,
                redirectUrl: `/customer/${single.id}`,
              }
              return acc.push(obj)
            }

            case 'conversations': {
              obj = {
                key: single.id,
                title: wrapText(`${get(['subject'], single, ' ')}`, 20),
                price: startCase(ele),
                image: inbox,
                redirectUrl: {
                  pathname: `/inbox`,
                  state: {
                    inboxId: single.id,
                    conversation: single,
                  },
                },
              }
              return acc.push(obj)
            }

            case 'tasks': {
              obj = {
                key: single.id,
                title: wrapText(`${get(['subject'], single, ' ')}`, 20),
                price: startCase(ele),
                image: task,
                redirectUrl: {
                  pathname: `/tasks`,
                  state: {
                    viewTaskIsOpen: true,
                    taskId: single.id,
                  },
                },
              }
              return acc.push(obj)
            }
            case 'articles': {
              obj = {
                key: single.id,
                title: wrapText(`${get(['name'], single, ' ')}`, 20),
                price: startCase(ele),
                description: wrapText(`${get(['plainContent'], single, ' ')}`, 20),
                image: book,
                redirectUrl: `/${KNOWLEDGEBASE_PATH.PREFIX}/${single.docId}/${KNOWLEDGEBASE_PATH.ARTICLES}/${single.id}`,
              }
              return acc.push(obj)
            }

            default:
              break
          }
        })

        return acc
      }, [])

      setSearch(search => ({...search, results: arr}))
    }
  }, [successLabels, globalSearchData])

  const doSearch = (e, {value}) => {
    setSearch({...search, value})
  }

  const handleResultSelect = (e, {result}) => {
    navigate(result.redirectUrl)
  }

  return (
    <>
      {isSearchEnable && (
        <VmoMenuItem className="globleSearch">
          <VmoSearch
            minCharacters={3}
            className="gsresult"
            type="search"
            input={{
              icon: (
                <i className="link icon" onClick={() => setIsSearchEnable(!isSearchEnable)}>
                  <FiX style={{marginTop: '8px'}} />
                </i>
              ),

              // value:search.value,
              placeholder: 'Search',
            }}
            // loading={search.isLoading}
            onResultSelect={handleResultSelect}
            onSearchChange={_.debounce(doSearch, 500, {
              isLeading: true,
            })}
            results={search.results}
            resultRenderer={({title, price, id, description, image}) => {
              return (
                <>
                  {id === 0 && <h5>Search Result : {search.results.length} </h5>}
                  <div className="gsdetail">
                    <div className="gsdetailhead" key="content">
                      {image && (
                        <div className="gsimg">
                          <VmoImage src={image} />
                        </div>
                      )}
                      <VmoHeader as="h3">
                        {title && title}
                        {description && <VmoHeaderSubheader className="mt-1">{description}</VmoHeaderSubheader>}
                      </VmoHeader>
                    </div>
                    {price && <div>{price}</div>}
                  </div>
                </>
              )
            }}
          />
        </VmoMenuItem>
      )}
      {!isSearchEnable && (
        <VmoTooltip
          content="Search"
          trigger={
            <VmoMenuItem onClick={() => setIsSearchEnable(!isSearchEnable)}>
              <FiSearch />
            </VmoMenuItem>
          }
        />
      )}
    </>
  )
}

export default GlobalSearch
